export const version = "units/5.6.0";
//# sourceMappingURL=_version.js.map